<template>
  <div class="row">
    <!--  导师咨询列表  -->
    <div class="flex xs12">
      <va-card title="咨询审核列表">
        <!--   审核状态筛选     -->
        <div class="row align-center mb-1">
          <div class="flex md12 xs12">
            <va-button-group>
              <va-button
                class="mb-2"
                flat
                disabled
                color="gray"
              >处理状态：</va-button>
              <va-button
                class="mb-2"
                v-for="auditStatus in consultingAuditType"
                :key="auditStatus.CODE"
                :color="computeStatusColor(auditStatus.CODE)"
                flat
                v-on:click="handleStatusChange(auditStatus.CODE)"
              >{{auditStatus.TEXT}}</va-button>
            </va-button-group>
          </div>
          <div class="flex md6 xs12 sm6">
            <va-input
              class="ma-0"
              :value="topic"
              placeholder="搜索咨询话题"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex md6 xs12">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="auditingConsultings"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listAuditingConsulting"
          api-mode
        >
          <!-- 导师名字 -->
          <template slot="mentorName" slot-scope="props">
            <va-button flat small color="gray" :to='{path:`/admin/mentors/getMentor/${props.rowData.candidate.uid}`}'>
              {{ props.rowData.candidate.nickname }}
            </va-button>
          </template>
          <template slot="statusSlot" slot-scope="props">
            <va-badge color= 'info'>
              {{ computeStatus(props.rowData.status).text }}
            </va-badge>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="查看" placement="top">
              <va-button flat small color="gray" icon="fa fa-eye"
                :to='{path:`getAuditingConsulting/${props.rowData.uid}`}'/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true; deleteUid=props.rowData.uid"/>
            </va-popover>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除导师咨询"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import auditingCourseApi from '../../../api/auditingCourse'
import { CONSULTING_AUDIT_TYPE } from '../../../utils/constants'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      auditingConsultings: [],
      topic: '',
      loading: true,
      pageSize: 10,
      totalCount: 0,
      totalPages: 1,
      deleteModal: false,
      deleteUid: null,
      mentorUid: null,
      consultingAuditType: CONSULTING_AUDIT_TYPE,
      mentorOptions: [],
      status: 0,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:mentorName',
          title: '导师',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'topic',
          title: '咨询话题',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:statusSlot',
          title: '审核状态',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listAuditingConsulting()
  },
  methods: {
    listAuditingConsulting (pageNumber = 1) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        status: this.status,
        topic: this.topic,
        mentorUid: this.$route.query.mentorUid,
      }
      auditingCourseApi.listAuditingConsulting(params).then(response => {
        this.auditingConsultings = response.auditingConsultings
        this.auditingConsultings.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.loading = false
      }).catch(error => alert(error))
    },
    confirmDelete () {
      if (this.deleteUid === null) return
      auditingCourseApi.deleteAuditingConsulting(this.deleteUid).then(response => {
        if (response.success === true) {
          this.showToast('删除成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listAuditingConsulting()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    search: debounce(function (topic) {
      this.topic = topic
      this.listAuditingConsulting()
    }, 400),
    computeStatusColor (status) {
      return this.status === status ? 'info' : 'gray'
    },
    computeStatus (status) {
      const data = {
        text: '',
      }
      CONSULTING_AUDIT_TYPE.map(x => {
        if (status === x.CODE) {
          data.text = x.TEXT
        }
      })
      return data
    },
    handleStatusChange (status) {
      this.status = status
      this.listAuditingConsulting()
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
